<template>
  <div class="category-empty">
    <nuxt-img
      src="/category-empty-image.svg"
      alt="Здесь пока нет товаров"
      width="100"
      height="100"
    />

    <h2 class="category-empty__title">Здесь пока нет товаров</h2>

    <the-button class="category-empty__button" to="/">На главную</the-button>
  </div>
</template>

<style lang="scss" scoped>
.category-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 330px;
  padding-top: 40px;

  &__title {
    margin-bottom: 40px;
    font-size: 20px;
    font-weight: 600;
    line-height: 23px;
    color: var(--ui-text-secondary);
  }

  &__button {
    width: 200px;
  }
}
</style>
